import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { Tabs } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import TabPanel from "./TabPanel";
import { Grid, Typography, Tab, Box, IconButton } from "../..";
import { GRAY } from "../../constants/colors/hex";
export function Tabbed(_ref) {
  var tabs = _ref.tabs,
    onClose = _ref.onClose,
    onChangeTab = _ref.onChangeTab;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    tabIndex = _useState2[0],
    setTabIndex = _useState2[1];
  var _tabs$tabIndex = tabs[tabIndex],
    bottomComponent = _tabs$tabIndex.bottomComponent,
    title = _tabs$tabIndex.title;
  useEffect(function () {
    onChangeTab(tabIndex);
  }, [tabIndex]);
  var handleChange = function handleChange(event, newValue) {
    setTabIndex(newValue);
  };
  var TabsMarkup = tabs.map(function (_ref2) {
    var label = _ref2.label;
    return /*#__PURE__*/React.createElement(Tab, {
      label: label,
      key: label
    });
  });
  var TabPanels = tabs.map(function (_ref3, index) {
    var sections = _ref3.sections;
    var Sections = sections.map(function (_ref4) {
      var label = _ref4.label,
        component = _ref4.component,
        action = _ref4.action;
      return /*#__PURE__*/React.createElement(Box, {
        mb: 2,
        key: "".concat(label, " tab ").concat(index)
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        key: "".concat(label, " section"),
        direction: "column",
        justifyContent: "center"
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        container: true,
        justifyContent: "space-between"
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(Typography, {
        style: {
          color: GRAY[10]
        },
        variant: "section",
        gutterBottom: true
      }, label.toUpperCase())), action && /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, action)), /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, component)));
    });
    return /*#__PURE__*/React.createElement(TabPanel, {
      index: index,
      selectedTabIndex: tabIndex,
      key: "".concat(title, " tab ").concat(index)
    }, Sections);
  });
  return /*#__PURE__*/React.createElement(Box, {
    p: 5
  }, /*#__PURE__*/React.createElement(Box, {
    pb: 5
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    align: "center",
    variant: "h5"
  }, title)), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Box, {
    mr: 1
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    "aria-label": "close drawer",
    role: "button",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Close, null)))))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    direction: "column"
  }, /*#__PURE__*/React.createElement(Tabs, {
    value: tabIndex,
    onChange: handleChange,
    indicatorColor: "primary",
    textColor: "primary",
    "aria-label": "sidebar content"
  }, TabsMarkup), TabPanels), bottomComponent && /*#__PURE__*/React.createElement(Box, {
    mt: 5
  }, bottomComponent));
}